import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Formik } from "formik";
import Logo from "../../../assets/images/Logo.svg";
import ForgotPassBanner from "../../../assets/images/forgot-password-banner.png";
import { SvgIcons } from "../../../components/common/SvgIcons";
import InputText from "../../../components/common/InputText";
import { forgotPassword } from "../../../services/authService";
import Loader from "../../../components/common/Loader";
import { ForgotPasswordSchema } from "../../../validations/Auth";
import ReCAPTCHA from "react-google-recaptcha";
import { nameBasedRoutes } from "../../../router/public";
import { toast } from "react-toastify";
import { MESSAGES } from "../../../constants/messages";

export const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [isRequestSuccessful, setRequestSuccessful] = useState(false);

  const [captchaCode, setCaptchaCode] = useState("");

  const onChangeCaptchaCode = (value: any) => {
    setCaptchaCode(value);
  };

  /**
   * * Submit Method to call when user request new password
   *
   * @async
   * @param {string} email
   * @returns {*}
   */
  const submitForm = async (email: string) => {
    if (!captchaCode) {
      toast.error(MESSAGES.captchInvalid);
      return;
    }
    setLoading(true);
    const from = "front";
    forgotPassword({ email, from })
      .then((response: any) => {
        setLoading(false);
        setRequestSuccessful(true);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  return (
    <>
      <Row className="g-0 vh-100 position-relative">
        <Col md={6} lg={4} className="h-100">
          <div className="h-100  p-4 p-md-4 pe-md-0 position-relative ps-md-0 text-center w-100 pb-md-0">
            <Row className="align-items-center g-0 justify-content-center login-left-inner pb-3">
              <Col md={10} lg={10} xl={8} xxl={8}>
                <div className="mb-2 pb-2">
                  <Link
                    to={nameBasedRoutes.home.path}
                    className="d-inline-block"
                  >
                    <Image
                      className="img-fluid"
                      src={Logo}
                      alt="Logo"
                      width={129}
                      height={130}
                    />
                  </Link>
                </div>
                <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">
                  Forgot Password
                </h1>

                {!isRequestSuccessful ? (
                  <p className="mb-1 pt-1 fs-13 gray-color">
                    A password reset link will be sent to your <br />
                    registered email.
                  </p>
                ) : (
                  <p className="mb-1 pt-1 fs-13 gray-color">
                    Your submission has been received. If we have an account
                    matching your email address, you will receive an email with
                    a link to reset your password.
                  </p>
                )}
                {!isRequestSuccessful ? (
                  <Formik
                    validationSchema={ForgotPasswordSchema}
                    onSubmit={(values, actions) => {
                      actions.setSubmitting(false);
                      submitForm(values.email);
                    }}
                    initialValues={{
                      email: "",
                    }}
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      errors,
                      touched,
                    }) => (
                      <Form
                        className="text-start pt-4"
                        noValidate
                        onSubmit={handleSubmit}
                      >
                        <InputText
                          controlId="email"
                          label="Email"
                          placeholder="Enter Email"
                          touched={touched.email}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          errorsField={errors.email}
                          value={values.email}
                        />
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_CPATCHA_KEY}
                          onChange={onChangeCaptchaCode}
                        />
                        <br />
                        <Button
                          className="fw-bold w-100"
                          variant="primary"
                          type="submit"
                        >
                          Send
                        </Button>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <Link to="/"></Link>
                )}
              </Col>
            </Row>
            <Row className="bottom-0 g-0 left  row w-100 login-btm pt-3 pb-3 text-center ">
              <Col lg={12} xl={12} xxl={12}>
                <Col lg={12}>
                  <h6 className="mb-0 fs-11 gray-color">Back to</h6>
                </Col>
                <Col lg={12}>
                  <Link
                    className="fw-bold text-decoration-none fs-13"
                    to={nameBasedRoutes.login.path}
                  >
                    Login
                  </Link>
                </Col>
              </Col>
            </Row>
          </div>
        </Col>
        <Col
          md={6}
          lg={8}
          className="mobileBannerActive h-100 position-fixed right-0"
        >
          <Image
            className="h-100 w-100"
            src={ForgotPassBanner}
            alt="Forgot Password Banner"
          />
          <div className="bottom-0 h4 pb-3 position-absolute pt-3 w-100 white-color text-center posti right-text-overlapp mb-0">
            CRANE SAFETY EXPERTS
          </div>
        </Col>
      </Row>

      <Loader isLoading={loading} />
    </>
  );
};
